/**
 * Shared `staleTime` values for data that outlives a single navigation.
 *
 * The client default is 5 seconds (`pages/Root`), which is right for anything the patient can
 * change from inside the app — their cart, rewards, memberships, profile — and wrong for practice
 * configuration, which only an admin edits. Naming the two tiers here keeps a warm navigation
 * serving branding and catalogue shape from cache instead of re-requesting them on every route.
 */
export const STALE_TIME = {
  /** Practice configuration and branding: platform, theme, location. */
  platformConfig: 1000 * 60 * 10,
  /** Catalogue shape: what is on sale, not what it costs this patient right now. */
  catalog: 1000 * 60 * 5,
  /** Patient-owned state the patient can change in-app: memberships, rewards, cart. */
  patientState: 1000 * 60 * 2,
} as const;
